import { Tooltip } from "@mui/material";
import React, { useCallback } from "react";
import SearchBoard from "../features/myTask/components/Filters/SearchBoard";
import CustomMenu from "./Menu";
import CustomMenuItem from "./Menu/CustomMenuItem";

const ToolTipWrapper = ({ children, isToolTip, toolTipTitle = "" }) => {
  return (
    <>
      {
        isToolTip ? <Tooltip title={toolTipTitle} placement="left">
          {children}
        </Tooltip> : children
      }
    </>
  )
}

const DropdownWithSearchbar = ({
  anchorEl,
  open,
  setAnchorEl,
  searchQuery,
  setSearchQuery,
  filteredCards,
  handleConfirmationPopup,
  renderItemLabel,
  ref = null,
  showNone = true,
  isToolTip = false
}) => {  
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return (
    <CustomMenu
      id="user-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      ref={ref}
    >
      <SearchBoard
        onSearch={(val) => setSearchQuery(val)}
        searchQuery={searchQuery}
      />

      {showNone && (
        <CustomMenuItem value="0" onClick={() => handleConfirmationPopup(0)}>
          <em>None</em>
        </CustomMenuItem>
      )}
      {filteredCards?.length === 0 && (
        <CustomMenuItem disabled>
          <em>No results found</em>
        </CustomMenuItem>
      )}
      {filteredCards?.map((item) => (
        <ToolTipWrapper key={`dropdownSearch-${item?.card?.card_id}`} isToolTip={isToolTip} toolTipTitle={item?.card?.title}>
          <CustomMenuItem
            key={item.card.card_id}
            value={item.card.card_id}
            onClick={() => {
              handleConfirmationPopup(item.card.card_id);
            }}
          >
            {renderItemLabel(item)}
          </CustomMenuItem>
        </ToolTipWrapper>
      ))
      }
    </CustomMenu>
  );
};

export default DropdownWithSearchbar;
